<template>
  <v-dialog v-model="modal"
            ref="dialog"
            width="600"
            scrollable
            persistent
            eager
            v-bind="$attrs"
            @keydown.esc="$emit('close')"
            @click:outside="$emit('close')">
    <v-card class="app-card card-borderless">
      <gg-toolbar v-if="isToolbarSlotActive" @close="$emit('close')">
        <slot name="toolbar"></slot>
      </gg-toolbar>
      <v-card-title v-if="isTitleSlotActive">
        <slot name="title"></slot>
      </v-card-title>
      <v-card-text class="pt-2 pb-3" v-if="isBodySlotActive">
        <slot name="body"></slot>
      </v-card-text>
      <v-card-actions v-if="isActionsSlotActive" class="justify-content-end pb-4">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GGModal',
  props: {
    isActive: {
      type: Boolean,
    }
  },
  data: () => ({
    modal: false
  }),
  created () {
    this.modal = this.isActive
  },
  mounted () {
    const modals = document.querySelectorAll('.v-dialog__content')

    modals.forEach(item => item.setAttribute('role', 'dialog'))
  },
  watch: {
    isActive: function (val) {
      this.modal = val
    }
  },
  computed: {
    isToolbarSlotActive () {
      return this.$slots.toolbar !== undefined
    },
    isTitleSlotActive () {
      return this.$slots.title !== undefined
    },
    isBodySlotActive () {
      return this.$slots.body !== undefined
    },
    isActionsSlotActive () {
      return this.$slots.actions !== undefined
    }
  }
}
</script>
